import React, { useEffect, useState } from "react";
import TableHeader from "../common/table/TableHeader";
import TableSkeleton from "../common/table/TableSkeleton";
import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../utils/baseUtils";
import ReactPaginate from "react-paginate";
import ViewGangLeader from "./ViewGangLeder";
import { capitalizeFirstLetter } from "../../utils/helper";
import handleError from "../../constant/handleError";
import axiosInstance from "../../utils/AxiosInstance";
import checkNetworkStatus from "../common/networkStatus/CheckNetworkStatus";
import useShowAlert from "../../utils/AlertUtiles";

function GangLederManagement() {

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [isSelectedData, setSelectedData] = useState({});
  const [isViewModelOpen, setViewModalOpen] = useState(false);
  const [isData, setData] = useState([]);
  const showAlert = useShowAlert();

  const [loading, setLoading] = useState({
    list: false,
  });

  const headers = [
    "S.No",
    "Date",
    "Name",
    "Phone",
    // "Pincode",
    "Capacity",   
    // "Action",
  ];
  
  const handleView =  (item) => {
    setSelectedData(item);
    setViewModalOpen(true);
  };

  const handleCloseView = async () => {
    setViewModalOpen(false);
  };

 const fetchGangLederList = async (page = 0,) => {
        setLoading((prev) => ({ ...prev, list: true }));
        checkNetworkStatus();

    try {
       const response = await axiosInstance.get(`partner/admin/approved?role=GANGLEADER&pageno=${page + 1}&limit=${uRLs.PER_PAGE}`);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
          const gangLeaders = (response.data.results || []).filter(
        (item) => item.role === "GANGLEADER"
      ); if (gangLeaders.length > 0) {
        setData(gangLeaders);
      }
      }
      else{
        setData([])
      }
      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setData([]);
      setTotalPages(0);
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, list: false }));
    }
  };

 useEffect(() => {
    fetchGangLederList (currentPage);
  }, [currentPage,]);

  return (
    <>
      <div className=" pe-3 mb-3">
        <div className="breadcrumb-title pe-3 mb-2">Captain Management</div>
      </div>

      <div className="col-col-12 ">
        <div className="card mb-0">
          <div className="card-body p-0">
            <table className="table align-middle table-hover mb-0 cursor-pointer ">
              <TableHeader headers={headers} />

              <tbody>
                {loading.list ? (
                  <TableSkeleton
                    rows={5}
                    columns={[300, 300, 300, 200,100  ]}
                  />
                ) : Array.isArray(isData) && isData.length > 0 ? (
                  isData.map((item, index) => (
                    <tr key={item._id || index}
                     onClick={() => handleView(item)}>
                      <td className="text-center">                    
                        {totalItems - (currentPage * uRLs.PER_PAGE + index)}
                      </td>
                      <td className="text-center">
                        {" "}
                        {
                          DateConverter.ISOToDisplayFormat(
                            DateConverter.convertToTimeZone(
                              item?.createdAt,
                              uRLs.TIMEZONE
                            )
                          ).date
                        }
                      </td>
                      <td className="text-center">{capitalizeFirstLetter(item.name)||"-"}</td>
                      <td className="text-center fw-bold">{item.mobileNumber||"-"}</td>
                       {/* <td className="text-center">{item.pincode||"-"}</td> */} 
                      <td className="text-center"><span className="badge rounded-pill bg-label-fall">
                        {item?.capacityInAcres}
                        </span></td>                  

                      {/* <td className="text-center">
                        <div className=" d-flex justify-content-center order-actions">
                          <button
                            type="button"
                            className="btn-label-primary shadow-none me-2"
                            onClick={() => handleView(item)}
                          >
                            <i className="lni lni-eye"></i>
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center p-2 text-muted">
                      <span className="text-muted">
                        No data found in this list.
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {totalPages > 0 && (
            <div className="d-flex justify-content-center mt-3">
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                breakLabel={"..."}
                onPageChange={({ selected }) => {
                  setLoading((prev) => ({ ...prev, list: true }));
                  setCurrentPage(selected);
                }}
                pageRangeDisplayed={5}
                pageCount={totalPages}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="active"
                forcePage={currentPage}
              />
            </div>
          )}
        </div>
        {isViewModelOpen && (
          <ViewGangLeader onClose={handleCloseView} isData={isSelectedData} setData={setData} isViewModelOpen={isViewModelOpen}/>
        )}
      </div>
    </>
  );
}

export default GangLederManagement;
